import React from 'react';

export default function IconBoxStyle8({ title, subTitle, iconUrl }) {
  return (
    <div className="cs_iconbox cs_style_8 text-center cs_radius_20" style={{
      maxWidth: '180px',
      width: '100%',
      padding: '20px 15px',
      margin: '0 auto'
    }}>
      <div className="cs_iconbox_icon rounded-circle cs_center" style={{
        width: '60px',
        height: '60px',
        marginBottom: '12px'
      }}>
        <img src={iconUrl} alt="Icon" style={{ width: '35px', height: '35px' }} />
      </div>
      <h2 className="cs_iconbox_title cs_semibold cs_fs_32" style={{ fontSize: '18px', marginBottom: '8px', lineHeight: '1.3' }}>{title}</h2>
      <p className="cs_iconbox_subtitle m-0" style={{ fontSize: '13px', lineHeight: '1.4' }}>{subTitle}</p>
    </div>
  );
}
